<template lang="pug">

  div

    v-dialog(v-model="visible" max-width="500px" :persistent="isTransferring")

      .dialogHeader

        .dialogHeaderTitle
          | Passar Master

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="closeDialog")

      .dialogBody

        .dialogBodyContent

          .searchInput
            input.searchField(
              ref="emailInput"
              v-model="userEmailNewMaster"
              type="text"
              :disabled="isEmailInputDisabled"
              maxlength="64"
              placeholder="Digite o e-mail do novo Master"
              @keyup.enter="foundUser ? confirmTransferMaster() : searchUser()"
            )
            .searchLoading(v-if="isNewMasterEmailValid && isSearching")
              v-progress-circular(indeterminate color="red" size="25")
            template(v-else-if="isUserFound")
              .searchFoundIcon.mdi.mdi-check
              .searchEditIcon.mdi.mdi-pencil(@click="editUser()" title="Alterar e-mail")
            sos-button(
              v-else-if="!isPreSelectedMode"
              :disabled="isSearchButtonDisabled"
              @buttonClick="searchUser()"
              color="purple"
              size="small"
              buttonIcon="mdi-magnify"
              buttonIconSize="20"
            )

          .searchHint(v-if="!isPreSelectedMode") Pressione Enter para pesquisar

          template(v-if="foundUser")
            .userInfo
              .userAvatar(:style="{ backgroundImage: 'url(' + (foundUser.image || userProfileBroken) + ')'}")
              .userDetails
                .userName {{ foundUser.name }}
                .userEmail {{ foundUser.email }}
                .userRole {{ foundUserRoleName }}

          .mt-4

            .transferButtonWrapper
              sos-button(
                @buttonClick="closeDialog()"
                buttonLabel="Fechar"
                :disabled="isTransferring"
                color="danger"
                size="medium"
                buttonIcon="mdi-close"
                buttonIconSize="20"
              ).mr-2
              template(v-if="isFoundUserHugolManaged")
                v-tooltip(top color="rgba(0, 0, 139, 0.95)")
                  template(v-slot:activator="{ on, attrs }")
                    div(v-bind="attrs" v-on="on")
                      sos-button(
                        :disabled="true"
                        buttonLabel="Não pode transferir"
                        color="warning"
                        size="medium"
                        buttonIcon="mdi-lock"
                        buttonIconSize="20"
                      )
                  span O papel deste usuário é definido pelo RM e não pode ser promovido a Master.
              template(v-else)
                sos-button(
                  ref="transferButton"
                  :disabled="isTransferButtonDisabled"
                  @buttonClick="confirmTransferMaster()"
                  buttonLabel="Confirmar transferência"
                  :loading="isTransferring"
                  color="success"
                  size="medium"
                  buttonIcon="mdi-check"
                  buttonIconSize="20"
                )

    //- Modal de mensagem
    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

</template>

<script>

  import { isEmailValid } from '@/utils.js'
  import { apiTransferGroupMaster, apiCheckUserInGroup } from '@/services/endpoints/groups'
  import {
    MASTER_USER_ROLE,
    MANAGER_USER_ROLE,
    MASTER_USER_ROLE_NAME,
    MANAGER_USER_ROLE_NAME,
    MEMBER_USER_ROLE_NAME
  } from '@/constants/userRoles'

  import SosButton from '@/components/SosButton'
  import ConfirmDialog from '@/modals/ConfirmDialog'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  import userProfileBroken from '@/assets/images/user-profile-broken.png'

  export default {
    name: 'DialogTransferMaster',

    components: {
      'sos-button': SosButton,
      'confirm-dialog': ConfirmDialog,
    },

    mixins: [
      confirmDialogMixin,
    ],

    props: {
      data: {
        type: Object,
        default: () => ({
          active: false,
          groupID: '',
          currentMasterUserID: '',
          preSelectedUser: null,
        }),
      },
    },

    data () {
      return {
        loadingNewMaster: false,
        isTransferring: false,
        isSearching: false,

        userEmailNewMaster: '',
        foundUser: null,
        isDialogClosing: false,
        preSelectedModeActive: false,
      }
    },

    computed: {
      visible: {
        get () {
          return this.data.active
        },
        set (value) {
          if (value === false) {
            this.$emit('close')
          }
        }
      },

      isPreSelectedMode: function () {
        return !!this.data.preSelectedUser === true && this.preSelectedModeActive === true
      },

      isNewMasterEmailValid: function () {
        return isEmailValid(this.userEmailNewMaster)
      },

      newMasterEmailLowerCase: function () {
        return String(this.userEmailNewMaster).trim().toLowerCase()
      },

      foundUserRoleName: function () {
        console.log('foundUserRoleName:', this.foundUser);
        if (!this.foundUser?.role) return MEMBER_USER_ROLE_NAME
        if (this.foundUser.role === MASTER_USER_ROLE) return MASTER_USER_ROLE_NAME
        if (this.foundUser.role === MANAGER_USER_ROLE) return MANAGER_USER_ROLE_NAME
        return MEMBER_USER_ROLE_NAME
      },

      isUserFound: function () {
        return !!this.foundUser === true
      },

      isEmailInputDisabled: function () {
        return this.isTransferring || this.isUserFound || this.isSearching
      },

      isSearchButtonDisabled: function () {
        return this.isTransferring || !this.isNewMasterEmailValid
      },

      isFoundUserHugolManaged: function () {
        return !!this.foundUser?.hugol?.employeeId || this.foundUser?.hugol?.origin === 'HUGOL'
      },

      isTransferButtonDisabled: function () {
        return this.isTransferring || !this.foundUser || this.isFoundUserHugolManaged
      },
    },

    watch: {
      'data.active': {
        immediate: true,
        handler (newValue) {
          if (newValue === true) {
            // Modal está abrindo
            this.open()
          }
        }
      },
    },

    methods: {
      focusEmailInput () {
        this.$nextTick(() => {
          if (this.$refs.emailInput) {
            this.$refs.emailInput.focus()
          }
        })
      },

      focusTransferButton () {
        this.$nextTick(() => {
          if (this.$refs.transferButton) {
            this.$refs.transferButton.$el.focus()
          }
        })
      },

      open () {
        this.visible = true
        this.clearFields()

        // Se tem usuário pré-selecionado, já define como encontrado
        if (this.data.preSelectedUser) {
          this.preSelectedModeActive = true
          const user = this.data.preSelectedUser

          this.foundUser = {
            userID: user.userID,
            name: String(user.userName || user.nome || '').trim(),
            email: String(user.userEmail || user.email || '').trim(),
            role: String(user.role || '').trim(),
            image: user.userImage || user.img || user.userImageIsValid === true
              ? (String(user.userImage || user.img || '').indexOf('https://') !== -1 ? String(user.userImage || user.img || '').trim() : userProfileBroken)
              : userProfileBroken,
          }

          this.userEmailNewMaster = this.foundUser.email

          // Focar no botão de transferência após encontrar usuário para permitir Enter confirmar
          this.focusTransferButton()
        } else {
          // Focar no input quando abrir o diálogo
          this.focusEmailInput()
        }
      },

      closeDialog () {
        if (this.isTransferring) return false
        this.visible = false
      },

      clearFields () {
        this.isTransferring = false
        this.loadingNewMaster = false
        this.isSearching = false
        this.userEmailNewMaster = ''
        this.foundUser = null
        this.preSelectedModeActive = false
      },

      async searchUser () {
        // Se o showMessage está aberto, não fazer nada (deixar o dialog fechar com Enter/Esc)
        if (this.$refs.cdConfirmModal?.dialog === true) {
          await this.$nextTick()
          setTimeout(() => {
            if (this.foundUser) {
              this.confirmTransferMaster()
            }
          }, 50)
          return
        }

        if (!this.isNewMasterEmailValid) {
          return false
        }

        // Verificar se o e-mail digitado é o próprio usuário
        const currentUserEmail = this.$store.state.app.userSession?.email?.trim()?.toLowerCase()
        if (this.newMasterEmailLowerCase === currentUserEmail) {
          this.isSearching = false
          this.foundUser = null
          return this.showMessage('Aviso!', 'Você não pode passar o Master para você mesmo.')
        }

        this.isSearching = true

        const checkUserResponse = await apiCheckUserInGroup({
          groupID: this.data.groupID,
          userEmail: this.newMasterEmailLowerCase
        })

        if (checkUserResponse.httpCode !== 200 || !checkUserResponse.data?.userID) {
          this.isSearching = false
          this.foundUser = null
          return this.showMessage('Falha!', checkUserResponse.message || 'Usuário não encontrado neste grupo.')
        }

        // Usuário encontrado - mostra informações
        this.foundUser = this.buildFoundUser(checkUserResponse.data)
        this.isSearching = false

        // Focar no botão de transferência após encontrar usuário para permitir Enter confirmar
        this.focusTransferButton()
      },

      buildFoundUser (data) {
        const userImg = data.userImg || ''
        const isValidImage = userImg.indexOf('https://') !== -1
        const hugol = data.hugol || {}

        return {
          userID: String(data.userID || ''),
          name: String(data.userName || '').trim(),
          email: String(data.userEmail || '').trim(),
          role: String(data.role || '').trim(),
          image: isValidImage ? userImg.trim() : userProfileBroken,
          hugol: hugol,
        }
      },

      editUser () {
        this.foundUser = null
        this.userEmailNewMaster = ''
        this.preSelectedModeActive = false
      },

      confirmTransferMaster () {
        if (!this.foundUser) {
          return
        }

        // Perguntar confirmação antes de transferir
        this.showConfirmBox({
          title: 'Confirmar transferência',
          text: `Tem certeza que deseja passar o Master do grupo para <b style="color: #4CAF50">${this.foundUser.name || this.foundUser.email}</b>?`,
          type: 'confirmTransferMaster',
          data: {
            groupID: this.data.groupID,
            newMasterUserID: this.foundUser.userID,
            newMasterName: this.foundUser.name,
            newMasterEmail: this.foundUser.email,
          },
          isResponse: false,
          buttonPosition: 'center',
          width: 400,
          closeText: 'Cancelar',
          continueText: 'Sim, confirmar',
        })
      },

      cdAction (cdResponse) {
        // Tratar resposta do confirm-dialog
        if (cdResponse === false) {
          return
        }

        const type = cdResponse.cdType
        const data = cdResponse.cdData

        if (type === 'confirmTransferMaster') {
          this.transferMaster(data)
        }
      },

      async transferMaster (data) {
        this.isTransferring = true

        try {
          const response = await apiTransferGroupMaster({
            groupID: data.groupID,
            newMasterUserID: data.newMasterUserID,
          })

          if (response.httpCode === 200) {
            // Emite evento para o pai mostrar a mensagem de sucesso
            this.$emit('transferSuccess', {
              title: response.title,
              message: response.message,
              oldMasterUserID: this.data.currentMasterUserID,
              newMasterUserID: data.newMasterUserID,
            })

            this.visible = false
          } else {
            this.showMessage('Erro!', response.message)
          }
        } catch (error) {
          this.showMessage('Erro!', 'Ocorreu um erro ao tentar realizar a transferência.')
        }

        this.isTransferring = false
      },
    },
  }

</script>

<style lang="scss" scoped>

  .searchField {
    width: 100%;
    height: 40px;
    background-color: #ffffff;
    padding: 0 60px 0 12px;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.25);
    outline: 0;
    font-size: 15px;

    &:disabled {
      background-color: #f5f5f5;
    }
  }

  .searchInput {
    position: relative;
    display: block;
    width: 100%;
    height: 40px;
    margin-bottom: 4px;

    .sosButton {
      position: absolute;
      top: 6px;
      right: 6px;
    }
  }

  .searchHint {
    font-size: 12px;
    color: #999;
    margin-bottom: 16px;
  }

  .searchLoading {
    position: absolute;
    top: 7px;
    right: 17px;
    width: 25px;
    height: 25px;
  }

  .searchFoundIcon {
    position: absolute;
    top: 7px;
    right: 47px;
    width: 30px;
    height: 25px;
    font-size: 22px;
    color: #4CAF50;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .searchEditIcon {
    position: absolute;

    width: 40px;
    height: 40px;
    right: 0;
    top: 0px;

    font-size: 20px;
    color: #2196F3;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    transition: all 0.2s ease;

    &:hover {
      background-color: #1d1d1d18;
      border-bottom-right-radius: 10px;
      border-top-right-radius: 10px;

      &:before {
        transform: scale(1.1);
      }
    }

    &::after {
      content: "";
      position: absolute;
      transform: translateX(50%);
      top: 0;
      left: -1px;
      width: 2px;
      height: 39px;
      background-color: rgba(0, 0, 0, 0.1);
    }
  }

  .userInfo {
    display: flex;
    align-items: center;
    padding: 12px;
    background-color: #e8f5e9;
    border-radius: 8px;
    margin-bottom: 16px;
    border: 1px solid #4CAF50;
  }

  .userAvatar {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    background-size: cover;
    background-color: #e0e0e0;
    flex-shrink: 0;
  }

  .userDetails {
    margin-left: 12px;
    overflow: hidden;
  }

  .userName {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    word-break: break-word;
  }

  .userEmail,
  .userRole {
    font-size: 13px;
    color: #666;
    margin-top: 2px;
    word-break: break-word;
  }

  .transferButtonWrapper {
    position: relative;
    display: inline-block;
    min-width: 200px;
    min-height: 40px;
  }

  .transferLoading {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 0;
  }

</style>
